import React, { Component } from "react"
import { connect } from 'react-redux';
import moment from 'moment'
import Checkbox from "@material-ui/core/Checkbox";
import { updateStatusAction, getInProgressAction } from '../../redux/actions/MyTaskAction';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import {ACollapse,TableCommittee} from "../../components"

import {
    data_status
} from '../../configs/datas'
import {Storage} from '../../configs'
import { data } from "jquery";

var base64 = require('base-64');
var utf8 = require('utf8');

class InprogressTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filter_method_status: '',
            filter_status_name: '',
            filter_doc_no: '',
            filter_po_contract_no: '',
            filter_po_header_text: '',
            filter_create_po_contract_emp_name: '',
            filter_saveBy: '',
            filter_editBy: '',
            filter_updatedate: '',
            inprogressArr:[],
            inprogressUpdateStatus:[],
            isShowButtonUpdateStatus: false,
            page:0,
            rowsPerPage: 10,

          };
          this.handlerEditClick=this.handlerEditClick.bind(this);
         this.handlerEditClick=this.handlerEditClick.bind(this);
         this.handleChange = this.handleChange.bind(this);
         this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    }

    getStatus(status_code) {
        const result = data_status.filter((data) => {
            return data.code === status_code
        })
        return result[0] ? result[0].description : ""
    }

    /* comment because dupplicate function
    handlerEditClick(rowIndex,transactionNo) {

        // console.log(rowIndex)
        // console.log(tasks[rowIndex])

        // history.push({
        //     pathname: '/main',
        //     state: { tasks: tasks[rowIndex] }
        // });

        let{inprogressArr} =  this.state;
        let { history } = this.props;
        if (transactionNo !== '') {
            var clickRowOntask = inprogressArr.filter((data) => {
                return data.transaction_no && data.transaction_no === transactionNo
            })

            if (clickRowOntask.length > 0) {
                history.push({
                    pathname: '/main',
                    state: { tasks: clickRowOntask[0], mode: 'EDIT' }
                });
            }
        }

    }*/

    async handleChange(event) {

        function rowFilter(dataColumn,filter,Type){
            if(Type==="TypeDate")
                dataColumn=moment(dataColumn).format('DD/MM/YYYY')
            
            if(filter === ' ')
            return dataColumn === null || dataColumn === ''
            else
            return dataColumn &&  dataColumn.toLowerCase().indexOf(filter.toLowerCase()) > -1
        }

        event.preventDefault()
        const { name, value } = event.target;

        await this.setState({ [name]: value })

        let searchtask = []
        searchtask = this.props.inProgress

        if (this.state.filter_method_status !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.Method_status,this.state.filter_method_status)
            })
        }
        if (this.state.filter_status_name !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.status_name,this.state.filter_status_name)
            })
        }
        if (this.state.filter_mom_no !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.mom_no,this.state.filter_mom_no)
            })
        }
        if (this.state.filter_doc_no !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.doc_no,this.state.filter_doc_no)
            })
        }
        if (this.state.filter_po_contract_no !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.po_contract_no,this.state.filter_po_contract_no)
            })
        }
        if (this.state.filter_po_header_text !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.po_header_text,this.state.filter_po_header_text)
            })
        }
        if (this.state.filter_create_po_contract_emp_name !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.create_po_contract_emp_name!==" "?data.create_po_contract_emp_name:"",this.state.filter_create_po_contract_emp_name)
            })
        }
        if (this.state.filter_saveBy !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.createBy_name,this.state.filter_saveBy)
            })
        }
        if (this.state.filter_editBy !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.reviewer_name,this.state.filter_editBy)
            })
        }
        if (this.state.filter_updatedate !== '') {
            searchtask = searchtask.filter((data) => {
                return rowFilter(data.updatedate,this.state.filter_updatedate,"TypeDate")
            })
        }

        await this.setState({ inprogressArr: searchtask, page: 0 })

    }


    handleChangeCheckbox(event, status, transactionNo){
        const user=Storage.getUser()
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (value === 0) {
            const arritem = this.state.inprogressUpdateStatus.filter((data) => {
                return data.transactionNo && data.transactionNo !== transactionNo
            })
            this.setState({ inprogressUpdateStatus: arritem })

        }

        if( value === 1) {
            let _updateStatus   = '' 

            if(status === 'BPCO' || status === 'BINC'){
                _updateStatus = 'BCOM'
                this.setState({isShowButtonUpdateStatus:true})
            }
            if(status === 'MCFM'){
                _updateStatus = 'MCOM'
                this.setState({isShowButtonUpdateStatus:true})
            }

            let itemUpdateStatus ={
                transactionNo: transactionNo,
                currentStatus:status,
                updateStatus: _updateStatus,
                userId:user.userName
            }

            this.state.inprogressUpdateStatus.push(itemUpdateStatus)
            this.setState({ inprogressUpdateStatus: this.state.inprogressUpdateStatus })
        }

    }

    handlerUpdateStatusClick(){
        const user=Storage.getUser()
        const role=Storage.getRole()
        const employeePIS=Storage.getEmployeePIS()

        if(this.state.inprogressUpdateStatus.length > 0){
            this.props.updateStatus(this.state.inprogressUpdateStatus).then(res =>{
                
                if(res.data.isSuccess){

                    this.setState({ inprogressUpdateStatus: [] })

                    if (this.props.role === 'C') {
                        this.props.getInProgress(2, user.userName, role, '');
                    }
            
                    if(this.props.role === 'R'){
                        this.props.getInProgress(2, '', role, employeePIS.departmentCode);
                    }
                }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.inProgress !== this.state.inprogressArr) {

            this.setState({
                inprogressArr: nextProps.inProgress
            })
            
        }
    }

    renderCheckbox(status, statusName, transaction_no) {

        return (
            status === 'BPCO' || status === 'BINC' || status === 'MCFM' || status === 'MCOM' || status === 'BCOM' ? (
                status === 'MCOM' || status === 'BCOM' ? (
                    <Checkbox
                        checked={status === 'MCOM' || status === 'BCOM' ? true : false}
                        color="primary"
                        disabled={true}
                        name={transaction_no}
                        id={transaction_no}
                    />
                ) : (
                        <Checkbox
                            color="primary"
                            disabled={false}
                            name={transaction_no}
                            id={transaction_no}
                            onClick={(event) => this.handleChangeCheckbox(event, status, transaction_no)}
                        />
                    )
            ) : (
                    <Checkbox
                        inputProps={{ "aria-labelledby": '' }}
                        color="primary"
                        disabled={true}
                        name={transaction_no}
                        id={transaction_no}
                    />
                )
        );
    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }
    handlerEditClick(rowIndex, transactionNo,doc_type) {

        //console.log(rowIndex)
        //console.log(transaction_no)

        let { history, tasks } = this.props;

        if (transactionNo !== '') {
            var clickRowOntask = tasks.filter((data) => {
                return data.transaction_no && data.transaction_no === transactionNo
            })

            if (clickRowOntask.length > 0) {

                let bytes_tran_no = utf8.encode(clickRowOntask[0].transaction_no);
                let encoded_transaction_no = base64.encode(bytes_tran_no);

                let bytes_po_contract_no = utf8.encode(clickRowOntask[0].po_contract_no);
                let encoded_po_contract_no = base64.encode(bytes_po_contract_no)
                
            if(doc_type === "BOT"){
                    history.push({
                        pathname: '/main',
                        search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                        state: { tasks: clickRowOntask[0], mode: 'EDIT' }
                    });
                }
                else {
                    history.push({
                        pathname: '/mainnotbot',
                        search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                        state: { tasks: clickRowOntask[0], mode: 'EDIT' }
                    });
                }

            }
        }
    }

    render() {
        let {tasks}=this.props;
        const {filter_method_status, filter_status_name, filter_mom_no, filter_doc_no, filter_po_contract_no, filter_po_header_text,
            filter_create_po_contract_emp_name, filter_saveBy, filter_editBy, filter_updatedate,inprogressArr } = this.state;

        const {page, rowsPerPage} = this.state
      

        return (
            <div className="sp-table-container">
                <div className="row no-gutters sp-table-content">
                    <div className="row no-gutters sp-table-content " style={{ minWidth: '900px' }}>
                        
                        <Table className="sp-table table rrs-table" >
                            <TableHead>
                                <TableRow className="sp-table-header">
                                    {/* <TableCell className="th-table text-center" style={{ width: '80px' }} >Mask Complete</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '180px' }} >Method</TableCell> */}
                                    <TableCell className="th-table text-center" style={{ width: '15px', maxWidth: '15px' }}></TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>สถานะ<br />เอกสาร</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>MOM<br />Doc No.</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>RRS<br />Doc No.</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>PO/Contract<br />No.</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '229px', maxWidth: '229px' }}>Header<br />Text</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '230px', maxWidth: '230px' }}>พนักงานจัดหาผู้รับผิดชอบ<br />PO/Contract</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '230px', maxWidth: '230px' }}>Create by</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '230px', maxWidth: '230px' }}>Edit by</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '120px', maxWidth: '120px' }}>Edit Date</TableCell>
                                    <TableCell className="th-table text-center" style={{ width: '60px', maxWidth: '60' }}>จำนวนวัน<br />คงเหลือ</TableCell>
                                </TableRow>
                                <TableRow className="sp-table-filter">
                                    {/* <TableCell></TableCell> */}
                                    {/* <TableCell><input type="text" name="filter_method_status" onChange={this.handleChange} value={filter_method_status} /></TableCell>*/}
                                    <TableCell></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_status_name" className="form-control" onChange={this.handleChange} value={filter_status_name} /></TableCell> 
                                    <TableCell><input type="text" placeholder=" " name="filter_mom_no"  className="form-control" onChange={this.handleChange} value={filter_mom_no} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_doc_no"  className="form-control" onChange={this.handleChange} value={filter_doc_no} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_po_contract_no"  className="form-control" onChange={this.handleChange} value={filter_po_contract_no} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_po_header_text"  className="form-control" onChange={this.handleChange} value={filter_po_header_text} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_create_po_contract_emp_name"  className="form-control" onChange={this.handleChange} value={filter_create_po_contract_emp_name} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_saveBy"   className="form-control" onChange={this.handleChange} value={filter_saveBy} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_editBy"   className="form-control" onChange={this.handleChange} value={filter_editBy} /></TableCell>
                                    <TableCell><input type="text" placeholder=" " name="filter_updatedate"  className="form-control" onChange={this.handleChange} value={filter_updatedate} /></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    inprogressArr ? (
                                        inprogressArr.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((inprogress, index) => {
                                                return (
                                                    <>
                                                    <TableRow key={"task_inprogress_" + ((page * rowsPerPage) + index) + "_" +  inprogress.transaction_no} 
                                                    style={{ cursor: 'pointer' }}>
                                                        {/* <TableCell className="text-center">
                                                            {
                                                                this.renderCheckbox(inprogress.status, inprogress.status_name, inprogress.transaction_no)
                                                            }
                                                        </TableCell>
                                                        <TableCell className="text-center">{inprogress.Method_status}</TableCell> */}
                                                        <TableCell><ACollapse isExpand='N' id={"task_inprogress_"+index}></ACollapse></TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-left">{inprogress.status_name}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-center">{inprogress.mom_no}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-center">{inprogress.doc_no}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-center">{inprogress.po_contract_no}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  style={{ "whiteSpace": "nowrap" }}>{inprogress.po_header_text}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-left">{inprogress.create_po_contract_emp_name}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-left">{inprogress.createBy_name}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-left">{inprogress.reviewer_name}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-center">{moment(inprogress.updatedate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell onClick={() => { this.handlerEditClick(index,inprogress.transaction_no,inprogress.doc_type) }}  className="text-left"><span className={ (inprogress.remain_date_no >= 0?"":" required")  }>{inprogress.remain_date_no}</span></TableCell>
                                                         
                                                    </TableRow>
                                                <TableRow validity="hidden"></TableRow>                                                 
                                                <TableRow key={"task_committee" + ((page * rowsPerPage) + index) + "_" +  inprogress.transaction_no}>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan="10" className="text-center" style={{borderWidth:"1px" ,BorderStyle:"solid"}}>

                                                    <TableCommittee id={"task_inprogress_"+index} isExpand="N" t_PO_COMMITTEE = {inprogress.t_PO_COMMITTEE} >
                                                </TableCommittee>      
                                                    </TableCell>
                                                </TableRow>
                                                </>
                                                );
                                            })) : (
                                            <TableRow key={0}>
                                                {/* <TableCell colSpan="11" className="text-center" style={{ */}
                                                
                                                <TableCell colSpan="11" className="text-center" style={{
                                                    textAlign: 'center',
                                                    fontStyle: 'italic',
                                                    color: 'gray'
                                                }}>No data</TableCell>
                                            </TableRow>
                                        )
                                }
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            component="div"
                            count={inprogressArr.length}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                            }}
                            onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                        />
                    </div>
                </div>
               
                <div className="rrs-detail pt-0">
                    <div className="row sp-table-content-footer">
                        <div className="col-12 sp-header-button-panel2">
                            {
                                this.state.isShowButtonUpdateStatus ?
                                    <a className="sp-btn-icon" onClick={() => { this.handlerUpdateStatusClick() }}>
                                        <i className="icon btn-order-savedraft" />
                                        <span className="sp-btn-icon-label">Save</span>
                                    </a> : null
                            }
                        </div>
                    </div>
                </div>          
            </div>
            
        )
    }
}

//export default InprogressTable
const mapStateToProps = state => {
    const { MyTaskRedux, UserRedux } = state
    return {
        resultUpdateStatus: MyTaskRedux.resultUpdateStatus,
        inProgress: MyTaskRedux.inProgress
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateStatus: (updateStatusArr) => dispatch(updateStatusAction(updateStatusArr)),
        getInProgress: (tabId, userId, userRole, userDepartment) => dispatch(getInProgressAction(tabId, userId, userRole, userDepartment)),
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(InprogressTable);